import { useState, useRef, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { CURRENCIES } from '../sell/adverts/Currency';
import {
    currencySelector,
    setCurrency,
} from '../../redux/reducers/common/common_reducers/currency';
import { onButtonKey } from '../../utils/common/a11y';

export const getCurrencySymbol = (currency) => {
    switch (currency) {
        case CURRENCIES.GEL:
            return '₾';
        case CURRENCIES.USD:
            return '$';
        case CURRENCIES.EUR:
            return '€';
        default:
            return currency;
    }
};

const CURRENCY_LABEL = {
    [CURRENCIES.GEL]: 'GEL',
    [CURRENCIES.USD]: 'USD',
    [CURRENCIES.EUR]: 'EUR',
};

export const SelectCurrency = () => {
    const dispatch = useDispatch();
    const currency = useSelector(currencySelector);
    const options = Object.values(CURRENCIES);
    const [isOpen, setIsOpen] = useState(false);
    const dropdownRef = useRef(null);

    useEffect(() => {
        const handler = (e) => {
            if (
                dropdownRef.current &&
                !dropdownRef.current.contains(e.target)
            ) {
                setIsOpen(false);
            }
        };
        document.addEventListener('mousedown', handler);
        return () => document.removeEventListener('mousedown', handler);
    }, []);

    const handleSelect = (value) => {
        dispatch(setCurrency(value));
        setIsOpen(false);
    };

    return (
        <div className="currency-dropdown" ref={dropdownRef}>
            <button
                className={`currency-dropdown__trigger ${isOpen ? 'currency-dropdown__trigger--open' : ''}`}
                onClick={() => setIsOpen((v) => !v)}
                type="button"
                aria-haspopup="listbox"
                aria-expanded={isOpen}
            >
                <span className="currency-dropdown__symbol">
                    {getCurrencySymbol(currency)}
                </span>
                <svg
                    className={`currency-dropdown__chevron ${isOpen ? 'currency-dropdown__chevron--up' : ''}`}
                    width="10"
                    height="10"
                    viewBox="0 0 10 10"
                    fill="none"
                >
                    <path
                        d="M2 3.5L5 6.5L8 3.5"
                        stroke="currentColor"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </svg>
            </button>

            {isOpen && (
                <ul className="currency-dropdown__menu" role="listbox">
                    {options.map((opt) => (
                        <li
                            key={opt}
                            className={`currency-dropdown__option ${opt === currency ? 'currency-dropdown__option--active' : ''}`}
                            role="option"
                            aria-selected={opt === currency}
                            tabIndex={0}
                            onClick={() => handleSelect(opt)}
                            onKeyDown={onButtonKey(() => handleSelect(opt))}
                        >
                            <span className="currency-dropdown__opt-symbol">
                                {getCurrencySymbol(opt)}
                            </span>
                            <span className="currency-dropdown__opt-label">
                                {CURRENCY_LABEL[opt]}
                            </span>
                            {opt === currency && (
                                <svg
                                    width="12"
                                    height="12"
                                    viewBox="0 0 12 12"
                                    fill="none"
                                    className="currency-dropdown__check"
                                >
                                    <path
                                        d="M2 6L5 9L10 3"
                                        stroke="currentColor"
                                        strokeWidth="1.8"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                </svg>
                            )}
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
};
